/**
 * Pure TEA update for scene-move name collision retry dialog.
 *
 * Shell: `SceneMoveCollisionDialog.vue`.
 */
import { assertNever } from "../lib/assertNever";
import type { UpdateFn } from "../lib/tea";

export type SceneMoveCollisionModel = {
  readonly draft: string;
};

export const initialSceneMoveCollisionModel: SceneMoveCollisionModel = {
  draft: "",
};

export type SceneMoveCollisionMsg =
  | { readonly type: "Seed"; readonly attemptedName: string }
  | { readonly type: "DraftChanged"; readonly draft: string }
  | { readonly type: "Submit" };

export type SceneMoveCollisionCmd =
  | { readonly kind: "focusInput" }
  | { readonly kind: "retry"; readonly name: string };

export function updateSceneMoveCollision(
  model: SceneMoveCollisionModel,
  msg: SceneMoveCollisionMsg,
): readonly [SceneMoveCollisionModel, readonly SceneMoveCollisionCmd[]] {
  switch (msg.type) {
    case "Seed":
      return [{ draft: msg.attemptedName }, [{ kind: "focusInput" }]];
    case "DraftChanged":
      return [{ draft: msg.draft }, []];
    case "Submit": {
      const name = model.draft.trim();
      if (name.length === 0) return [model, []];
      return [model, [{ kind: "retry", name }]];
    }
    default:
      return assertNever(msg);
  }
}

export const updateSceneMoveCollisionFn: UpdateFn<
  SceneMoveCollisionModel,
  SceneMoveCollisionMsg,
  SceneMoveCollisionCmd
> = updateSceneMoveCollision;
